let entityDecoder: HTMLTextAreaElement | null = null;

export function decodeHtmlEntities(value: string | undefined | null): string {
  if (!value) return '';
  // Fast path: most titles don't include entities.
  if (!value.includes('&')) return value;

  if (typeof document === 'undefined') return value;
  if (!entityDecoder) entityDecoder = document.createElement('textarea');

  entityDecoder.innerHTML = value;
  return entityDecoder.value;
}
